<template>
    <b-modal
        id="portfolio-edit-title-modal"
        v-if="canEditTitle"
        ref="portfolio-edit-title-modal"
        :title="$t('portfolio.edit_title')"
        :ok-disabled="!project.title"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        @ok="onOk()">
        <div class="portfolio-title">
            <b-form-group
                :label="$t('common.title')"
                label-for="portfolio-title-input">
                <b-form-input
                    id="portfolio-title-input"
                    v-model="project.title"
                    :placeholder="$t('common.title')">
                </b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-portfolio-show-edit-title-component',
    props: {
        projectIn: Object,
        canEditTitle: Number,
    },
    data() {
        return {
            project: this.projectIn,
        };
    },
    methods: {
        onOk() {
            this.alert.saving();

            const data = {
                title: this.project.title,
            };

            this.axios.post(this.routes.baseUrl() + '/project/' + this.project.id + '/title', data).then(
                (response) => {
                    this.title = response.data.title;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
